export default function hash (h) {
    location.hash = h
}